// @flow
import template from '../../template';

/**
 * @private
 */
export default (): string => template`
  export function up(schema) {

  }

  export function down(schema) {

  }
`;
